import {Vue, Component} from 'vue-property-decorator';
import {ICachedData, IMissedCallCachedData, STATUS_ACTIVE} from "../../../../models/common/cached-data.model";
import {LocalforageWrapper} from "../../../../utils/localforage-wrapper";
import EventBus from "../../../../utils/event-bus";
import {EVENT_BUS} from "../../../../common/constants";
import {formatPhoneNumberForDisplay} from "../../../../utils/util";

@Component({
    name: 'MissedIncomingCall',
    computed: {
        STATUS_ACTIVE() {
            return STATUS_ACTIVE
        }
    },
    template: require('./template.html')
})
export default class MissedIncomingCall extends Vue {
    data: IMissedCallCachedData[] = []
    isShowMissedCall: boolean = true
    fakeKey = 'Key'

    private async handleLoadDataFromCached() {
        const dataCatch = await LocalforageWrapper.getItem(this.fakeKey) as ICachedData<IMissedCallCachedData>
        if (dataCatch && (dataCatch as any).length > 0) {
            // handle mapping from cached
            this.handleSortFollowStatus(dataCatch as any)
        }
    }

    private handleSortFollowStatus(arr : Array<IMissedCallCachedData>) {
        this.data = arr.sort((a,b) => b.is_active - a.is_active)
    }

    public async handleClearAll() {
        await LocalforageWrapper.setItem(this.fakeKey, [])
        this.data = []
        this.handleLoadDataFromCached()
    }

    public async handleClickOneItemMissedCall(item) {
        const phone = item.phone
        this.data = this.data.map(missedCall => {
            if (missedCall.phone === phone) {
                item.is_active = STATUS_ACTIVE.NOT_ACTIVE
            }
            return missedCall
        })

        await LocalforageWrapper.setItem(this.fakeKey, this.data)
        this.handleLoadDataFromCached()
    }

    public formatPhone(phone: string): string {
        return formatPhoneNumberForDisplay(phone);
    }

    mounted() {
        this.handleLoadDataFromCached()
        EventBus.$on(EVENT_BUS.NOTIFICATION.NOTIFICATION_LOG_INCOMING_CALL, async (payload) => {
            console.log('payload from incoming form', payload)

            const incomingCall = {
                phone: payload.phoneNumber,
                name: '',
                provider: '',
                time: new Date().toLocaleDateString(),
                is_active: STATUS_ACTIVE.ACTIVE,
            }
            await LocalforageWrapper.setItem(this.fakeKey, [incomingCall, ...this.data,])

            this.handleLoadDataFromCached()
        })
    }
}